import { AuthCard } from '@/auth/components/auth-card';
import { Button } from '@/common/components/button';
import { Seo } from '@/common/components/seo';
import { EmptyState, EmptyStateImage, EmptyStateMessage } from '@/shared/components/empty-states';

export function ExpiredSessionPage() {
  return (
    <>
      <Seo title="Expired Session" />
      <main className="flex flex-col md:flex-row h-full w-full p-0">
        <AuthCard>
          <EmptyState>
            <EmptyStateImage src="/img/disconnected_plugs.svg" alt="An illustration of two plugs that have been unplugged from each other."/>
            <EmptyStateMessage>
              Your login session has expired.
            </EmptyStateMessage>
            <Button to="/login">OK</Button>
          </EmptyState>
        </AuthCard>
      </main>
    </>
  );
}
